import { render, staticRenderFns } from "./Overlay.vue?vue&type=template&id=315b6e56&"
import script from "./Overlay.js?vue&type=script&lang=js&"
export * from "./Overlay.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/mijnmooiestraat.vlaanderen/staging.mijnmooiestraat.vlaanderen/pro-staging.mijnmooiestraat.vlaanderen/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('315b6e56')) {
      api.createRecord('315b6e56', component.options)
    } else {
      api.reload('315b6e56', component.options)
    }
    module.hot.accept("./Overlay.vue?vue&type=template&id=315b6e56&", function () {
      api.rerender('315b6e56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/Overlay/Overlay.vue"
export default component.exports